document.addEventListener('DOMContentLoaded', () => {
    const trigger = document.querySelector('#infinite-scroll-trigger');
    const container = document.querySelector('#posts-container');

    if (!trigger || !container) return;

    const observer = new IntersectionObserver(async (entries) => {
        if (!entries[0].isIntersecting) return;

        observer.disconnect();
        trigger.classList.add('loading');

        const nextPage = trigger.dataset.nextPage;
        if (!nextPage) return;

        try {
            const response = await fetch(nextPage);
            const html = await response.text();

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newPosts = doc.querySelectorAll('#posts-container > *');
            const newTrigger = doc.querySelector('#infinite-scroll-trigger');

            newPosts.forEach(post => container.appendChild(post));

            trigger.classList.remove('loading');

            if (newTrigger) {
                trigger.dataset.nextPage = newTrigger.dataset.nextPage;
                observer.observe(trigger);
            } else {
                trigger.remove(); // fim dos posts
            }

        } catch (e) {
            trigger.classList.remove('loading');
            observer.observe(trigger); // tenta novamente
        }
    });

    observer.observe(trigger);
});
